/**
 * @generated SignedSource<<dd2c17b0c13ed10899f758eecd977a3d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CategorySelectorCreateCategoryMutation$variables = {
  connections: ReadonlyArray<string>;
  name: string;
  orgId?: string | null;
};
export type CategorySelectorCreateCategoryMutation$data = {
  readonly createAnnotationCategory: {
    readonly annotationCategory: {
      readonly color: string | null;
      readonly id: string;
      readonly name: string;
      readonly organizationId: string | null;
      readonly uuid: string;
    } | null;
    readonly errors: ReadonlyArray<string | null> | null;
  } | null;
};
export type CategorySelectorCreateCategoryMutation = {
  response: CategorySelectorCreateCategoryMutation$data;
  variables: CategorySelectorCreateCategoryMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orgId"
},
v3 = [
  {
    "kind": "Literal",
    "name": "generateColor",
    "value": true
  },
  {
    "kind": "Variable",
    "name": "name",
    "variableName": "name"
  },
  {
    "kind": "Variable",
    "name": "orgId",
    "variableName": "orgId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "AnnotationCategory",
  "kind": "LinkedField",
  "name": "annotationCategory",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uuid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "organizationId",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errors",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CategorySelectorCreateCategoryMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "CreateAnnotationCategory",
        "kind": "LinkedField",
        "name": "createAnnotationCategory",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "CategorySelectorCreateCategoryMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "CreateAnnotationCategory",
        "kind": "LinkedField",
        "name": "createAnnotationCategory",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "appendNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "annotationCategory",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "AnnotationCategoryEdge"
              }
            ]
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9620a09c7431714bf3bc2f7d204da050",
    "id": null,
    "metadata": {},
    "name": "CategorySelectorCreateCategoryMutation",
    "operationKind": "mutation",
    "text": "mutation CategorySelectorCreateCategoryMutation(\n  $name: String!\n  $orgId: ID\n) {\n  createAnnotationCategory(name: $name, orgId: $orgId, generateColor: true) {\n    annotationCategory {\n      uuid\n      name\n      id\n      color\n      organizationId\n    }\n    errors\n  }\n}\n"
  }
};
})();

(node as any).hash = "80f4950e32d35ef3fc5a36c48e2b0ea9";

export default node;
